import React, { Fragment, useState } from "react"

import PvSidebar from "./PvSidebar"
import PvPaperWidths from "./PvPaperWidths"
import PvTemplates from "./PvTemplates"
import PvPrintButton from "./PvPrintButton"
import { haveAuth } from "utils"
import classes from "./index.module.scss"

const selectedPrinterResolution = 8

const PrinterViewer = () => {
  const [printType, setPrintType] = useState("")
  const [printData, setPrintData] = useState({})
  const [selectedPaperWidth, setSelectedPaperWidth] = useState(72)

  const showPrintButton =
    !!printType &&
    haveAuth(["printerAccess"])

  return (
    <Fragment>
      <PvSidebar
        printType={printType}
        setPrintType={setPrintType}
        setPrintData={setPrintData}
      />
      <div className={classes["container"]}>
        <PvPaperWidths
          selectedPaperWidth={selectedPaperWidth}
          setSelectedPaperWidth={setSelectedPaperWidth}
        />
        <PvTemplates
          printType={printType}
          printData={printData}
          selectedPaperWidth={selectedPaperWidth}
        />
        {
          showPrintButton &&
          <PvPrintButton
            key={printType}
            printType={printType}
            printData={printData}
            selectedPaperWidth={selectedPaperWidth}
            selectedPrinterResolution={selectedPrinterResolution}
          />
        }
      </div>
    </Fragment>
  )
}

export default PrinterViewer